import { GlobeAltIcon } from '@heroicons/react/24/outline';
import {
  Outlet, useLocation, useNavigate, useParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../assets/images/logo.svg';

export default function StationJourneyLayout() {
  const { locale } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();

  const switchLanguage = () => {
    const nextLocale = locale === 'ar' ? 'en' : 'ar';
    const nextPath = location.pathname.replace(/^\/(ar|en)(?=\/|$)/, `/${nextLocale}`);

    i18n.changeLanguage(nextLocale).then(() => {
      localStorage.setItem('locale', nextLocale);
      document.documentElement.lang = nextLocale;
      document.documentElement.dir = nextLocale === 'ar' ? 'rtl' : 'ltr';
      navigate(`${nextPath}${location.search}${location.hash}`, { replace: true });
    });
  };

  return (
    <main className='min-h-screen bg-gray-50'>
      <header className='border-b border-gray-200 bg-white'>
        <div className='mx-auto flex h-16 max-w-lg items-center justify-between px-4'>
          <img src={logo} alt='Chaizer' className='h-7 w-auto' />
          <button
            type='button'
            onClick={switchLanguage}
            className='inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium text-secondary hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'
          >
            <GlobeAltIcon className='h-5 w-5' aria-hidden='true' />
            {t('stationJourney.changeLanguage')}
          </button>
        </div>
      </header>
      <div className='mx-auto flex min-h-[calc(100vh-4rem)] max-w-lg items-center px-4 py-8'>
        <Outlet />
      </div>
    </main>
  );
}
